<template>
  <OTable :title="title" :table-class="tableClass">
    <thead>
      <tr>
        <th v-for="(headCellValue, i) in headRow" :key="`${headCellValue}-${i}`" v-text="$t(`${sizechartI18nPrefix}.${headCellValue}`)" />
      </tr>
    </thead>
    <tbody>
      <tr v-for="(bodyRow, ix) in AllBodyRows" :key="`${bodyRow}-${ix}`">
        <td v-for="(bodyRowValue) in bodyRow" :key="bodyRowValue" v-text="$t(`${sizechartI18nPrefix}.${bodyRowValue}`)" />
      </tr>
    </tbody>
  </OTable>
</template>

<script>
import { SizechartZones } from '@/enums/sizechart'
import OTable from '@/components/OTable'

export default {
  name: 'HipsterSizeChart',
  components: { OTable },
  props: {
    sizechartZone: {
      type: String,
      default: SizechartZones.eu
    },
    tableClass: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    sizechartI18nPrefix () {
      return 'Sizechart.HipsterSizeChart'
    },
    bodyRowHead () {
      return ['XS', 'S', 'M', 'L', 'XL']
    },
    headRow () {
      return ['Size', 'ClothingSize'].map(value => this.$t(`${this.sizechartZone}.${value}`))
    },
    AllBodyRows () {
      return this.bodyRowHead.reduce((acc, bodyRowHeadValue) => {
        const [, ...headRows] = [...this.headRow]
        const bodyRow = [`${this.sizechartZone}.${bodyRowHeadValue}`, ...headRows.map(headRow => this.$t(`${headRow}${bodyRowHeadValue}`))]

        acc.push(bodyRow)

        return acc
      }, [])
    }
  }
}
</script>
